import React, { FormEvent, useEffect, useReducer, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  CustomerModel,
  BlockApplicationModel,
  ConstructorModel
} from '../../../domain/models'
import {
  fetchCustomer,
  fetchConstructor,
  fetchBlockTest,
  deleteTestApplication,
  fetchTestApplication,
  saveTestApplication
} from '../../../main/usecases'
import { TestCardPersonalityFactory } from '../../../main/factories'

import { maskCpf, dateToday } from '../../utils'
import { useTestBlock, useOnChangeDetect, useModalBox } from '../../contexts'
import {
  Button,
  ServicesHeader,
  SubHeader,
  Checkbox,
  Input,
  Loading,
  TestCard
} from '../../components'
import { ModelsModal } from './components'

import {
  IconPlusSvg,
  IconReturnSvg,
  IconSaveSvg,
  IconDropdownSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'
import TestCardCustom from '../../components/test-card-custom'

const TestApplication = ({ match, setTab }: any) => {
  const [values, setValues] = useState<any>({})
  const [customer, setCustomer] = useState<CustomerModel>()
  const [constructor, setConstructor] = useState<ConstructorModel[]>()
  const [loading, setLoading] = useState(false)
  const [dropdownIsOpen, setDropdownIsOpen] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const navigate = useLocation()
  const alert = useAlert()
  const { valuesToBlock } = useTestBlock()
  const { modalBox } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()
  const [disable, setDisable] = useState(true)
  const [cdAplicacaoTeste, setCdAplicacaoTeste] = useState<number>()
  const initialState = valuesToBlock

  const reduceUser = (state: any, action: any) => {
    switch (action.type) {
      case 'render':
        return action.newValue
      case 'checkBoxRender':
        const newValueAux = action.newValue.map((item: any) => {
          return {
            ...item,
            position: Math.random() + Math.random() + Math.random()
          }
        })
        return [...state, ...newValueAux]
      case 'clean':
        return []
      case 'delete':
        const filterAux = state.filter(
          (item: any) => item.position !== action.position
        )
        if (filterAux.length === 0) {
          setRefresh(!refresh)
          setDisable(true)
        }
        return filterAux
      case 'load':
        const responseAux = action.response?.blocosAplicados?.map(
          (item: any) => {
            return {
              ...item,
              position: Math.random() + Math.random() + Math.random()
            }
          }
        )
        return action.response?.blocosAplicados?.length > 0
          ? [...responseAux, ...state]
          : [...state]
      case 'concat':
        return [...action.response.blocosAplicados, ...state]

      case 'updateCard':
        const exists = state.find(
          (item: BlockApplicationModel) =>
            item.position === action.data.position
        )

        if (exists) {
          return state.map((item: BlockApplicationModel) => {
            if (item.position === action.data.position) {
              return action.data
            }
            return item
          })
        } else {
          return [...state, action.data]
        }
    }
  }
  const [blockTest, dispatch] = useReducer(reduceUser, initialState)

  const handleChekbox = (checked: boolean, name: string) => {
    setValues((prev: any) => ({ ...prev, [name]: checked }))
  }

  const handleRenderTestCard = async () => {
    setDropdownIsOpen(false)

    const selectedConstructors = Object.keys(values)
      ?.filter((item) => values[item])
      .map((item) => {
        return constructor?.find((el) => {
          return el?.construto === item
        })
      })

    try {
      const responseBlockTest = await fetchBlockTest().post(
        selectedConstructors
      )
      dispatch({ type: 'checkBoxRender', newValue: responseBlockTest })
    } catch (error) {
      console.error(error)
    } finally {
      setValues({})
    }
  }

  const handleRemoveRenderTestCard = async ({ id, position }: any) => {
    try {
      setLoading(true)
      if (id) {
        await deleteTestApplication({
          idService: match?.params?.idassessment,
          id: id
        }).delete()
        alert.show('Teste deletado com sucesso', {
          type: 'success',
          timeout: 1000
        })
        dispatch({ type: 'delete', position: position })
        setLoading(false)
      } else if (position >= 0) {
        dispatch({ type: 'delete', position: position })
        setTimeout(setLoading, 300, false)
      }
    } catch (error) {
      setLoading(false)
      console.error(error)
      alert.show('Erro ao deletar um teste', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleOpenModelsModal = () => {
    modalBox(
      <ModelsModal blocksInScreen={blockTest} dispatch={dispatch} />,
      'Modelo',
      '40%'
    )
  }

  useEffect(() => {
    setDropdownIsOpen(false)
  }, [navigate])
  useEffect(() => {
    for (let cont = 0; cont < blockTest.length; cont++) {
      if (blockTest[cont].resultadoTeste.teste) {
        if (!blockTest[cont].resultadoTeste.teste.cdTeste) {
          setDisable(true)
          break
        } else {
          setDisable(false)
        }
      } else {
        if (!blockTest[cont].resultadoTeste.customTeste) {
          setDisable(true)
          break
        } else {
          setDisable(false)
        }
      }
    }
  }, [blockTest])

  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseConstructor = await fetchConstructor().load()

        const responseTestApplication = await fetchTestApplication({
          id: match?.params?.idassessment
        }).load()
        setCdAplicacaoTeste(responseTestApplication.cdAplicacaoTeste)
        dispatch({ type: 'load', response: responseTestApplication })

        setCustomer(responseCustomer)
        setConstructor(responseConstructor)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    })()
  }, [match?.params?.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: FormEvent) => {
    setDisable(true)
    event.preventDefault()

    const body = blockTest.map((item: BlockApplicationModel) => {
      return {
        ...(item.cdBlocoAplicacaoTeste && {
          cdBlocoAplicacaoTeste: item.cdBlocoAplicacaoTeste
        }),
        construto: {
          cdConstruto: item?.construto?.cdConstruto
        },
        resultadoTeste: {
          construto: item?.construto?.cdConstruto,
          customTeste: item?.resultadoTeste?.customTeste,
          teste: item?.resultadoTeste?.teste?.cdTeste
            ? {
                cdTeste: item?.resultadoTeste?.teste?.cdTeste
              }
            : undefined,
          ...(item.resultadoTeste.controleGeral && {
            controleGeral: item.resultadoTeste.controleGeral
          }),
          ...(item.resultadoTeste.afetividade && {
            afetividade: item.resultadoTeste.afetividade
          }),
          ...(item.resultadoTeste.organizacaoDaPersonalidade && {
            organizacaoDaPersonalidade:
              item.resultadoTeste.organizacaoDaPersonalidade
          }),
          ...(item.resultadoTeste.agressividade && {
            agressividade: item.resultadoTeste.agressividade
          }),
          ...(item.resultadoTeste.maturidadeEEmotividade && {
            maturidadeEEmotividade: item.resultadoTeste.maturidadeEEmotividade
          }),
          ...(item.resultadoTeste.impulsividade && {
            impulsividade: item.resultadoTeste.impulsividade
          }),
          ...(item.resultadoTeste.relacionamentoInterpessoal && {
            relacionamentoInterpessoal:
              item.resultadoTeste.relacionamentoInterpessoal
          }),
          ...(item.resultadoTeste.energiaVitalProdutividade && {
            energiaVitalProdutividade:
              item.resultadoTeste.energiaVitalProdutividade
          }),
          ...(item.resultadoTeste.alterecaoPsiquicas && {
            alterecaoPsiquicas: item.resultadoTeste.alterecaoPsiquicas
          }),
          incluirBloco: item?.resultadoTeste?.customTeste
            ? false
            : item?.resultadoTeste?.incluirBloco,
          numeroPontos: item?.resultadoTeste?.numeroPontos,
          percentil: item?.resultadoTeste?.percentil,
          resultado: item?.resultadoTeste?.resultado,
          observacao: item?.resultadoTeste?.observacao,
          data: item?.resultadoTeste?.data
            ? item?.resultadoTeste?.data
            : dateToday
        }
      }
    })

    try {
      await saveTestApplication({
        id: match?.params?.idassessment
      }).post(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })
      // goToUrl(history, `/meus-pacientes/${match?.params?.id}/prontuario`)
      if (setTab) {
        setTab(2)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao salvar o Teste', {
        type: 'error',
        timeout: 4000
      })
    }
    setDisable(false)
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Testes psicológicos"
          disabled={disable}
        />
        <S.UseModelContainer>
          <Button onClick={handleOpenModelsModal} type="button">
            Modelos
          </Button>
        </S.UseModelContainer>
        <S.ButtonAddTestContainer>
          {loading ? (
            <Loading />
          ) : (
            blockTest?.map((item: any) => {
              if (item.construto.categoriaConstruto === 'LAYOUT_PADRAO') {
                return (
                  <TestCard
                    cdAplicacao={cdAplicacaoTeste || 0}
                    setDisable={setDisable}
                    disable={disable}
                    dispatch={dispatch}
                    constructor={item}
                    onRemove={() => {
                      handleRemoveRenderTestCard({
                        id: item.cdBlocoAplicacaoTeste || null,
                        position: item.position
                      })
                    }}
                    match={match}
                  />
                )
              } else if (
                item.construto.categoriaConstruto === 'LAYOUT_COMPLEMENTAR'
              ) {
                return (
                  <TestCardCustom
                    cdAplicacao={cdAplicacaoTeste || 0}
                    setDisable={setDisable}
                    match={match}
                    disable={disable}
                    dispatch={dispatch}
                    constructor={item}
                    onRemove={() => {
                      handleRemoveRenderTestCard({
                        id: item.cdBlocoAplicacaoTeste || null,
                        position: item.position
                      })
                    }}
                  />
                )
              } else {
                return (
                  <TestCardPersonalityFactory
                    cdAplicacao={cdAplicacaoTeste || 0}
                    setDisable={setDisable}
                    disable={disable}
                    match={match}
                    dispatch={dispatch}
                    constructor={item}
                    onRemove={() => {
                      handleRemoveRenderTestCard({
                        id: item.cdBlocoAplicacaoTeste || null,
                        position: item.position
                      })
                    }}
                  />
                )
              }
            })
          )}
          <Button
            onClick={() => {
              setDropdownIsOpen(!dropdownIsOpen)
              setSearchTerm('')
            }}
            className="add-test-button"
            hasblueButton
            initialIcon={<IconPlusSvg className="initial-icon" />}
            endIcon={<IconDropdownSvg className="end-icon" />}
          >
            Adicione um teste
          </Button>

          {dropdownIsOpen && (
            <>
              <S.DropdownContainer id="scrollableDiv">
                <Input
                  name="search"
                  autoComplete="off"
                  type="search"
                  placeholder="Pesquise..."
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setSearchTerm(e.target.value)
                  }
                />
                {loading ? (
                  <Loading />
                ) : (
                  constructor
                    ?.filter((value: ConstructorModel) => {
                      if (searchTerm === '') {
                        return value
                      } else if (
                        value.construto
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase())
                      ) {
                        return value
                      }
                      return null
                    })
                    .map((item) => (
                      <Checkbox
                        key={item.cdConstruto}
                        name={item.construto}
                        label={item.construto}
                        labelFor={item.construto}
                        onCheck={(e) => handleChekbox(e, item.construto)}
                      />
                    ))
                )}
              </S.DropdownContainer>
              {!!Object.values(values).find((item) => item === true) && (
                <S.ButtondropdownContainer>
                  <Button onClick={handleRenderTestCard}>Aplicar</Button>
                </S.ButtondropdownContainer>
              )}
            </>
          )}
        </S.ButtonAddTestContainer>
        <S.ButtonsContainer>
          <Button
            onClick={onSubmit}
            initialIcon={<IconSaveSvg />}
            className="button-save"
            disabled={disable}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link
              to={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
            >
              Retornar à listagem
            </Link>
          </Button>
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default TestApplication
